import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import ContentWrapper from '../../components/contentwrapper/ContentWrapper';
import { Table, Form } from 'react-bootstrap';
import Skeleton from 'react-loading-skeleton';
import { fetchAllDataAPI, filterByParams } from '../../utils/api';
import ReportNavBar from '../../components/ReportNavBar';
import { numberFormat } from '../../components/numberFormat';
import withAuth from '../../utils/withAuth';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
import moment from 'moment';
import { CiExport } from "react-icons/ci";
import CsvDownloader from 'react-csv-downloader';

const CourierWiseReport = () => {
    const [isLoading, setIsloading] = useState(false);
    const [order, setOrder] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');

    const [dateRange, setDateRange] = useState({
        startDate: new Date().toLocaleDateString('en-US'),
        endDate: new Date().toLocaleDateString('en-US'),
    });

    useEffect(() => {
        getCourierWiseReport();
    }, []);

    const getCourierWiseReport = () => {
        setIsloading(true);
        fetchAllDataAPI('super-admin-get-report-courier-wise-of-over-all').then((res) => {
            if (res.data.status === 1) {
                setOrder(res.data.order || []);
            }
            setIsloading(false);
        });
    };

    const handleFilterByDate = async (event, picker) => {
        setIsloading(true);
        const selectedRange = {
            startDate: picker.startDate.format("YYYY-MM-DD"),
            endDate: picker.endDate.format("YYYY-MM-DD")
        };
        setDateRange({
            startDate: picker.startDate.toDate(),
            endDate: picker.endDate.toDate()
        });

        try {
            const res = await filterByParams('super-admin-get-filter-report-courier-wise-of-over-all', selectedRange);
            if (res.data.status === 1) {
                setOrder(res.data.order || []);
            }
        } catch (error) {
            console.error("Error fetching filtered dealer report:", error);
        }
        setIsloading(false);
    };

    const filteredOrder = order.filter(item =>
        item.ocourier_name?.toLowerCase().includes(searchTerm)
    );

    const columns = [
        { id: 's_no', displayName: 'Serial No' },
        { id: 'courier_name', displayName: 'Courier Name' },
        { id: 'total_order', displayName: 'Total Order' },
        { id: 'total_intransit', displayName: 'Total IN Transit' },
        { id: 'total_cancelled', displayName: 'Total Cancelled' },
        { id: 'total_returned', displayName: 'Total Returned' },
        { id: 'total_delivered', displayName: 'Total Delivered' },
        { id: 'pending_amt', displayName: 'Pending Amt' },
        { id: 'recieved_amt', displayName: 'Recieve Amt' },
        { id: 'total_delivered_amt', displayName: 'Total Delivered Amt' },
        { id: 'total_amt', displayName: 'Total Amount' },
        { id: 'delivery_percentage', displayName: 'Delivery Percentage (%)' },
    ];

    const exportReport = filteredOrder.map((item, index) => ({
        s_no: index + 1,
        courier_name: item.ocourier_name || '',
        total_order: item.total_order,
        total_intransit: item.total_intransit,
        total_cancelled: item.total_cancelled,
        total_returned: item.total_returned,
        total_delivered: item.total_delivered,
        pending_amt: item.pending_amt,
        recieved_amt: item.recieved_amt,
        total_delivered_amt: item.total_delivered_amt,
        total_amt: item.total_amt,
        delivery_percentage: (Number(item.delivery_percentage) || 0).toFixed(2) + '%'
    }))

    const handleReset = () => window.location.reload();

    return (
        <div className="myprofile">
            <Helmet>
                <title>SATKARTAR::COURIER REPORT</title>
            </Helmet>
            <ContentWrapper>
                <ReportNavBar />
                <div className="card tablecard" style={{ marginBottom: "65px" }}>
                    <div className="d-flex justify-content-between flex-wrap align-items-center p-2">
                        <h5 className="mb-0 text-uppercase">Courier Wise Report</h5>
                        <Form.Control
                            type="text"
                            placeholder="Search Courier"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value.toLowerCase())}
                            className="mb-2"
                            style={{ maxWidth: "250px" }}
                        />
                        <div className="d-flex gap-2 align-items-center flex-wrap">
                            <CsvDownloader
                                filename={`courier_report_${moment().format("YYYY_MM_DD")}`}
                                extension=".csv"
                                datas={exportReport}
                                columns={columns}
                                className="btnorderfilter"
                            >
                                <CiExport className="svgexport" />
                                <span style={{ color: "#fff", border: "none" }} className="btn btn-info btn-sm btnfilter">
                                    Export
                                </span>
                            </CsvDownloader>
                            <span onClick={handleReset} className="btnreset">Reset</span>
                            <DateRangePicker
                                initialSettings={{
                                    startDate: dateRange.startDate,
                                    endDate: dateRange.endDate
                                }}
                                onApply={handleFilterByDate}
                            >
                                <button className="btn btn-sm btndateramge">Select Date Range</button>
                            </DateRangePicker>
                        </div>
                    </div>

                    <div className="table-responsive">
                        <Table className="table-sm" responsive striped bordered hover>
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Courier Name</th>
                                    <th>Total Order</th>
                                    <th>Total IN Transit</th>
                                    <th>Total Cancelled</th>
                                    <th>Total Returned</th>
                                    <th>Total Delivered</th>
                                    <th>Pending Amt</th>
                                    <th>Recieve Amt</th>
                                    <th>Total Delivered Amt</th>
                                    <th>Total Amount</th>
                                    <th>Delivery Percentage(%)</th>
                                </tr>
                            </thead>
                            <tbody>
                                {isLoading ? (
                                    [...Array(5)].map((_, index) => (
                                        <tr key={index}>
                                            {Array.from({ length: 12 }).map((_, tdIndex) => (
                                                <td key={tdIndex}><Skeleton /></td>
                                            ))}
                                        </tr>
                                    ))
                                ) : filteredOrder.length ? (
                                    filteredOrder.map((record, index) => (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>{record?.ocourier_name}</td>
                                            <td>{record?.total_order}</td>
                                            <td>{record?.total_intransit}</td>
                                            <td>{record?.total_cancelled}</td>
                                            <td>{record?.total_returned}</td>
                                            <td>{record?.total_delivered}</td>
                                            <td>{numberFormat(record?.pending_amt)}</td>
                                            <td>{numberFormat(record?.recieved_amt)}</td>
                                            <td>{numberFormat(record?.total_delivered_amt)}</td>
                                            <td>{numberFormat(record?.total_amt)}</td>
                                            <td>{(Number(record?.delivery_percentage) || 0).toFixed(2)}%</td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan={12} className="text-center">Data not found...</td>
                                    </tr>
                                )}
                            </tbody>
                            <tfoot>
                                <tr>
                                    <th className="text-end" style={{ fontWeight: "600", color: "#000" }} colSpan={2}>Grand Total</th>
                                    <th style={{ fontWeight: "600", color: "#000" }}>{filteredOrder.reduce((acc, cur) => acc + Number(cur.total_order || 0), 0)}</th>
                                    <th style={{ fontWeight: "600", color: "#000" }}>{filteredOrder.reduce((acc, cur) => acc + Number(cur.total_intransit || 0), 0)}</th>
                                    <th style={{ fontWeight: "600", color: "#000" }}>{filteredOrder.reduce((acc, cur) => acc + Number(cur.total_cancelled || 0), 0)}</th>
                                    <th style={{ fontWeight: "600", color: "#000" }}>{filteredOrder.reduce((acc, cur) => acc + Number(cur.total_returned || 0), 0)}</th>
                                    <th style={{ fontWeight: "600", color: "#000" }}>{filteredOrder.reduce((acc, cur) => acc + Number(cur.total_delivered || 0), 0)}</th>
                                    <th style={{ fontWeight: "600", color: "#000" }}>{numberFormat(filteredOrder.reduce((acc, cur) => acc + Number(cur.pending_amt || 0), 0))}</th>
                                    <th style={{ fontWeight: "600", color: "#000" }}>{numberFormat(filteredOrder.reduce((acc, cur) => acc + Number(cur.recieved_amt || 0), 0))}</th>
                                    <th style={{ fontWeight: "600", color: "#000" }}>{numberFormat(filteredOrder.reduce((acc, cur) => acc + Number(cur.total_delivered_amt || 0), 0))}</th>
                                    <th style={{ fontWeight: "600", color: "#000" }}>{numberFormat(filteredOrder.reduce((acc, cur) => acc + Number(cur.total_amt || 0), 0))}</th>
                                    <th style={{ fontWeight: "600", color: "#000" }}>
                                        {(
                                            filteredOrder.reduce((acc, cur) => acc + Number(cur.delivery_percentage || 0), 0) /
                                            (filteredOrder.length || 1)
                                        ).toFixed(2)}%
                                    </th>
                                </tr>
                            </tfoot>
                        </Table>
                    </div>
                </div>
            </ContentWrapper>
        </div>
    );
};

export default withAuth(CourierWiseReport);
